import React, { useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Grid, CircularProgress } from '@material-ui/core';
import clsx from 'clsx';
import { getAgentFeaturePermissions, Agent } from '@moderepo/mode-internal-apis';
import { ritzDataContext, selectLoggedInAgent, selectProjectAgent, selectProjectById } from '@moderepo/mode-data-state-ritz';
import { ITEMS_PER_PAGE_5 } from '@moderepo/mode-app-components';
import { UIFetchIssueFilters } from '@moderepo/mode-data-state-robot-cloud';
import { useRitzTranslation } from '../../utils/customHooks';
import { HomeDevicesContainer } from '../homes/HomeDevicesContainer';
import { RCIssuesContainer } from '.';



/**
 * Define the list of fields we want to hide in the IssuesTable. This data is static so don't need define inside the component.
 */
const issuesTableDisplayHiddenFields = {
    homeId         : true,
    alertId        : true,
    values         : true,
    ticketLink     : true,
    createdAgentId : true,
    resolvedAgentId: true,
    resolvedAt     : true,
};



export const RCHomeDetailsPage: React.FC = () => {
    // Get the params from the route or url
    const params = useParams();
    const projectId = Number(params.projectId);
    const userId = params.userId ? Number(params.userId) : undefined;       // OPTIONAL - Depending how the agent gets to this page
    const homeId = Number(params.homeId);

    const { state:dataState } = useContext(ritzDataContext);
    const loggedInAgent = selectLoggedInAgent(dataState) as Agent;
    const project = selectProjectById(dataState, projectId);
    const projectAgent = loggedInAgent ? selectProjectAgent(dataState, project?.id, loggedInAgent.id) : undefined;


    const { trans } = useRitzTranslation(project);
    const permissions = getAgentFeaturePermissions(projectAgent);


    // Similar to issuesTableDisplayHiddenFields but this one is dynamic so we need to define it inside component when we have data ready
    const [issuesTableDisplayFilters] = useState<UIFetchIssueFilters>({ pageNumber: 0, pageSize: 0, homeId, resolved: false });



    return (
        <div className={clsx('page-main-content')}>
            <div className="title-bar">
                <div className="title-bar-item title-text">
                    <div className="page-title">
                        {trans('page.title.home')}
                    </div>
                    <div className="page-subtitle">
                        {trans('page.subtitle.home')}
                    </div>
                </div>
            </div>


            {project && (
                <div>
                    <Grid container spacing={3}>

                        {permissions.canViewHomeDevices && (
                            <>
                                <Grid item xs={12}>
                                    <HomeDevicesContainer
                                        className="match-height"
                                        projectId={projectId}
                                        userId={userId}
                                        homeId={homeId}
                                        gatewaysOnly
                                    />
                                </Grid>
                            </>
                        )}

                        <Grid item xs={12}>
                            <RCIssuesContainer
                                className="match-height"
                                projectId={projectId}
                                homeId={homeId}
                                userId={userId}
                                itemsPerPage={ITEMS_PER_PAGE_5}
                                readonly
                                hiddenFields={issuesTableDisplayHiddenFields}
                                filters={issuesTableDisplayFilters}
                                showFilterOptions
                            />
                        </Grid>

                    </Grid>
                </div>
            )}

            {!project && (
                <CircularProgress />
            )}
        </div>
    );
};
